import React, {Component} from 'react';
import TableRow from './TableRow'
import User from '../../helpers/user'
import i18 from '../../i18'
import companyApi from "../../api/companyApi";


class Company extends Component {

    constructor(props) {
        super(props)
        this.state = {
            companies: [],
        }
    }

    componentDidMount = () => {

        companyApi.list().then((data) => {
                User.setUserData('enabledModules', data.enabledModules);
                this.setState({
                    companies: data.companies,
                });
            });
    }

    getCompanies = () => {
        let CompaniesList = []
        for (let index in this.state.companies) {
            let company = this.state.companies[index];
            CompaniesList.push(<TableRow
                key={company.id}
                index={index}
                company={company}/>)
        }

        return CompaniesList.length > 0 ? CompaniesList : <tr>
            <td colSpan="6" className='text-center'>{i18.COMPANY._noCompaniesFoud}</td>
        </tr>
    }


    render() {
        return (
            <div className='container-fluid'>
                <section id='companies'>
                    <table className='table table-striped table-aibook-no-border'>
                        <thead>
                        <tr>
                            <th>{i18.COMPANY._name}</th>
                            <th>{i18.COMPANY._bookingIntervall}</th>
                            <th className='text-center'>Vevő</th>
                            <th className='text-center'>Szállító</th>
                            <th className='text-center' style={{width: "auto"}}>{i18.COMPANY._operations}</th>
                        </tr>
                        </thead>
                        <tbody>
                        {this.getCompanies()}
                        </tbody>
                    </table>
                </section>
            </div>
        )
    }
}

export default Company


// WEBPACK FOOTER //
// ./src/components/company/Company.js